import PropTypes from 'prop-types';

import Flex from 'shopper/components/Flex';
import Price from 'shopper/components/Price';

import { toFormattedOfferOldPrice, toFormattedOfferPrice } from 'lib/offer';

const OfferPrice = ({ offerOldPrice, offerPrice, offerPriceType }) => (
  <Flex flex="2" alignItems="flex-end">
    <Price
      primaryInfo={toFormattedOfferPrice(offerPrice, offerPriceType)}
      secondaryInfo={toFormattedOfferOldPrice(offerOldPrice, offerPriceType)}
      mt={[4, null, 6]}
    />
  </Flex>
);

OfferPrice.defaultProps = {
  offerOldPrice: null,
};

OfferPrice.propTypes = {
  offerOldPrice: PropTypes.number,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
};

export default OfferPrice;
